var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"requests"},_vm._l((_vm.requests),function(request,idx){return _c('div',{key:idx},[_c('pre',[_vm._v(_vm._s(request))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }